// Switch name for the tips
export const PROVIDER_ONBOARDING_EXPERIENCE = 'pro_onboarding_experience_apo4294_20240305';

export const SET_UP_PAYMENT_VIEWED = 'SET_UP_PAYMENT_TOOL_TIP_VIEWED';
